import "core-js/modules/es6.array.reduce";

/**
 * @param {formattersType} formatters - formatters type
 */
export function evaluateFormatters(formatters) {
  return function (value, extra) {
    return formatters.reduce(function (parameters, formatter) {
      return {
        value: formatter(parameters.value, parameters.extra),
        extra: extra
      };
    }, {
      value: value,
      extra: extra
    }).value;
  };
}